import * as React from "react";
import { inject, observer } from "mobx-react";
import {  autorun } from "mobx";
import ModelStore from "src/stores/ModelStore";
import "./ThreeViewComponent.scss";
import * as THREE from "three";
import GLTFLoader from 'three-gltf-loader';
import { OrbitControls } from 'three-orbitcontrols-ts' 
import { TweenLite }  from 'gsap';

interface IState {
  open : boolean;
}
interface IProps {
  modelStore?: ModelStore;
}
@inject("modelStore")
@observer
export default class ThreeViewComponent extends React.Component<IProps, IState> {
  
  private autoUpdateDisposer: any;
  private scene: THREE.Scene;
  private renderer: THREE.WebGLRenderer;
  private camera: THREE.PerspectiveCamera;
  private mixer: THREE.AnimationMixer;
  private clips: THREE.AnimationClip[];
  private frameId: number;
  private mount: HTMLDivElement;
  private _modelId: string;
  private _colorId: string;
  

  

  constructor(props?: any, context?: any) {
    super(props, context);
    this.state = { open: false };
    this.animate = this.animate.bind(this);
    this.playAnimation = this.playAnimation.bind(this);
    this.clickNext=this.clickNext.bind(this);
    this.clickPrevious=this.clickPrevious.bind(this);
    this.onWindowResize=this.onWindowResize.bind(this);
  }

  public set modelId(p:string){
      if(p !== this._modelId){
          this._modelId = p; 
          if(this.scene){
            this.loadModel();
          }
          
      }
  }

  public set colorId(p:string){
    if(p !== this._colorId){
        this._colorId = p; 
        if(this.scene){
          this.loadTexture();
        }
        
    }
}
 

  public componentDidMount() {

    this.autoUpdateDisposer = autorun(() => {
      const modelStore = this.props.modelStore as ModelStore;
      if(modelStore.selectedModel !== null && modelStore.selectedModel!.models.length > 0){
        this.modelId = modelStore.selectedModel!.models[0]
      }
      if(modelStore.selectedPrintColors !== null){
        this.colorId = modelStore.selectedPrintColors;
      }
    });

    const width = this.mount.clientWidth;
    const height = this.mount.clientHeight;
    // ADD SCENE
    this.scene = new THREE.Scene();
    // ADD CAMERA
    this.camera = new THREE.PerspectiveCamera(35, width / height, 0.1, 1000);
    this.camera.position.set(15, 15, 15);
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));

    // ADD LIGHT
   
    this.scene.add( new THREE.AmbientLight( 0xffffff ) );

     /*
    const directionalLight = new THREE.DirectionalLight( 0xffffff, 1 );
    directionalLight.position.set( 1, 1, 1 ).normalize();
    this.scene.add( directionalLight );
    const pointLight = new THREE.PointLight( 0xffffff, 2, 100 );
    pointLight.position.z=-3;
    pointLight.position.y=3;
    pointLight.position.x=2;
    this.scene.add( pointLight );
    */

    // ADD RENDERER
    this.renderer = new THREE.WebGLRenderer({ antialias: true , alpha: true  });
    this.renderer.setSize(width, height);
    this.mount.appendChild(this.renderer.domElement);
   
    // ORBIT CONTROLS
    const controls = new OrbitControls(this.camera, this.renderer.domElement)
    controls.enableDamping = true
    controls.dampingFactor = 0.25
    controls.enableZoom = false

    this.start();
    if(this._modelId){
      this.loadModel();
    }

    

    

  }
  public componentWillUnmount() {
    this.stop();
    this.mount.removeChild(this.renderer.domElement);
    this.autoUpdateDisposer();
  }

  public render() {

    const modelStore = this.props.modelStore as ModelStore;

    return (
      <div className={"three-wrap step-" +  modelStore.selectedIndex }>
      <div className="three-view"
        ref={mount => {
          this.mount = mount as HTMLDivElement;
        }}
      />
      <h3 className="step-title">{modelStore.headline} </h3>
      <div className="footer">
          <button className="toggle-fold-button"  onClick={this.clickPrevious}>Zurück</button>
          <button className="toggle-fold-button"  onClick={this.playAnimation}>{this.state.open ? "Entfalten": "Falten"}</button>
          <button className="next-step-button"    onClick={this.clickNext}>Weiter</button>
      </div>
      
      </div>
    );
  }

  public componentDidUpdate(){
    this.onWindowResize();
  }
  

  private start() {
    if (!this.frameId) {
      this.frameId = requestAnimationFrame(this.animate);
      window.addEventListener( 'resize', this.onWindowResize, false );
    }
  }
  private stop() {
    cancelAnimationFrame(this.frameId);
    window.removeEventListener( 'resize', this.onWindowResize, false );
  }
  private animate() {

    this.renderScene();
    this.frameId = window.requestAnimationFrame(this.animate);
  }
  private renderScene() {
    if(this.mixer){
      this.mixer.update(0.025);
    }
    this.renderer.render(this.scene, this.camera);
  }

  private clearScene(){
    // const modelStore = this.props.modelStore as ModelStore;
    for(let i=this.scene.children.length-1;i>=0;i--){
        if(this.scene.children[i].type === "Mesh" || this.scene.children[i].type === "Scene"){
          this.scene.remove(this.scene.children[i]); 
        }
    }
    TweenLite.to(this.camera.position,1,{x:15,y:15,z:15,onUpdate:this.onUpdate.bind(this)})
    

    
     
  }
  private onUpdate(){
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));
  }
  private addEdgeGeometry( obj: THREE.Object3D ){

    for(let i=0;i<=obj.children.length-1;i++){
      if(obj.children[i].type === "Mesh"){
          const mesh = obj.children[i] as THREE.Mesh    
          mesh.material =  new THREE.MeshLambertMaterial( {color: 0xffffff , side: THREE.DoubleSide } );
          const edges = new THREE.EdgesGeometry( mesh.geometry ,10);    
          const line = new THREE.LineSegments( edges, new THREE.LineBasicMaterial( { color: 0x000000  ,linewidth: 1 } ) );
          mesh.add( line ); 
      }
      this.addEdgeGeometry(obj.children[i]);
    }
  }

  private clickPrevious(){
    this.props.modelStore!.previousStep();
  }
  private clickNext(){
    this.props.modelStore!.nextStep();
  }

  private playAnimation(){

    
    let i=0;
  
    
    for(i=0; i< this.clips.length; i++){
        const action = this.mixer.clipAction(this.clips[i]);
        action.paused = false;
        action.setLoop(THREE.LoopOnce, 0 ); 
        // action.clampWhenFinished=true;
        // action.play();
        if(this.state.open){
          //  action.timeScale = 1;
          //  action.play().clampWhenFinished=true;
          action.clampWhenFinished=false;
          action.timeScale = -1;
          action.play();
          
        }else{
          // action.timeScale = -1;
          // action.play();
          action.reset();
          action.timeScale = 1;
          action.clampWhenFinished=true;
          action.play();
        }
        
    }  
    this.setState({open: !this.state.open })   
} 
  private  loadTexture(){

  const colorURL ="/assets/konfigurator/textures/" + this._colorId.toLowerCase().replace(/[,\s]/g,"-") + ".png";  
  console.log("colorURL",colorURL);
  const texturemap = new THREE.TextureLoader().load( colorURL );
  
  /*
  const material = new THREE.MeshPhongMaterial( {
    color: 0xffffff,
    map: texturemap,
    shininess: 25,
    side: THREE.BackSide,
    specular: 0x333333    
  } ); 
  */
  const material = new THREE.MeshLambertMaterial( {
    color: 0xffffff,
    map: texturemap,
    side: THREE.FrontSide 
  } ); 

  this.addMaterial(this.scene,material);
}

private addMaterial( obj: THREE.Object3D , material: THREE.Material ){  
  for(let i=0;i<=obj.children.length-1;i++){
    if(obj.children[i].type === "Mesh"){
        const mesh = obj.children[i] as THREE.Mesh    
        mesh.material =  material;
        mesh.material.needsUpdate=true;
    }
    this.addMaterial(obj.children[i],material);
  }
}



  private  onWindowResize(){
      const width = this.mount.clientWidth;
      const height = this.mount.clientHeight;
      this.camera. aspect = width / height;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize( width, height );
  }
  
  private loadModel(){
    console.log("loadModel" , this._modelId )
    this.clearScene();
    this.setState({open:false});
    const loader = new GLTFLoader();
    loader.load(
     this._modelId ,
    ( gltf ) => {
        // called when the resource is loaded
        this.scene.add( gltf.scene );
        this.addEdgeGeometry(gltf.scene);
        this.mixer = new THREE.AnimationMixer(this.scene);

        const modelStore = this.props.modelStore as ModelStore;
        let scale = 1;
        if(modelStore.selectedModel!.scale &&  modelStore.selectedModel!.scale!==""){
          scale=parseFloat(modelStore.selectedModel!.scale);
          console.log("scale",scale)
        }
        gltf.scene.scale.set(scale,scale,scale);

        this.clips = gltf.animations;  
    },
    ( xhr ) => {
        // called while loading is progressing
       //  console.log( `${( xhr.loaded / xhr.total * 100 )}% loaded` );
    },
    ( error ) => {
        // called when loading has errors
        console.error( 'An error happened', error );
    },
);
  }
  

}



// WEBPACK FOOTER //
// ./src/components/ThreeViewComponent.tsx